import { render } from "./container.html?vue&type=template&id=2f439cd9&scoped=true&lang=html&external"
import script from "./container.vue?vue&type=script&lang=js"
export * from "./container.vue?vue&type=script&lang=js"

import "./_container.mobile.scss?vue&type=style&index=0&id=2f439cd9&lang=scss&scoped=true&external"
import "./_container.desktop.scss?vue&type=style&index=1&id=2f439cd9&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f439cd9"]])

export default __exports__